/**
 * Payment UI types — backend rows are mapped here by the page adapter.
 */

export type PaymentMethod = 'Cash' | 'Check' | 'Bank Transfer' | 'Credit Card';
export type PaymentStatus = 'Completed' | 'Pending' | 'Failed';

export interface Payment {
  paymentId: string;
  customer: string;
  invoiceNumber: string;
  method: PaymentMethod;
  amount: string;
  date: string;
  reference: string;
  status: PaymentStatus;
  // Original backend id for row-level actions (refund, etc.)
  id: number;
}

export const methodStyles: Record<PaymentMethod, { bg: string; color: string; border: string }> = {
  Cash:           { bg: '#F0FDF4', color: '#16A34A', border: '#BBF7D0' },
  Check:          { bg: '#EFF6FF', color: '#2563EB', border: '#BFDBFE' },
  'Bank Transfer':{ bg: '#FDF4FF', color: '#9333EA', border: '#E9D5FF' },
  'Credit Card':  { bg: '#FFF7ED', color: '#EA580C', border: '#FED7AA' },
};

export const statusStyles: Record<PaymentStatus, { color: string }> = {
  Completed: { color: '#16A34A' },
  Pending:   { color: '#D97706' },
  Failed:    { color: '#DC2626' },
};

export const METHOD_OPTIONS = ['All Methods', 'Cash', 'Check', 'Bank Transfer', 'Credit Card'] as const;

/**
 * Maps backend payment_method enum (cash|check|ach|credit_card|wire|other)
 * to the four-bucket UI label.
 */
export function backendMethodToUi(method: string): PaymentMethod {
  switch (method) {
    case 'cash': return 'Cash';
    case 'check': return 'Check';
    case 'ach':
    case 'wire': return 'Bank Transfer';
    case 'credit_card': return 'Credit Card';
    default: return 'Cash';
  }
}

/**
 * Inverse mapping for the create form.
 */
export function uiMethodToBackend(method: string): 'cash' | 'check' | 'ach' | 'credit_card' | 'other' {
  switch (method) {
    case 'Cash': return 'cash';
    case 'Check': return 'check';
    case 'Bank Transfer': return 'ach';
    case 'Credit Card': return 'credit_card';
    default: return 'other';
  }
}

export function backendStatusToUi(status: string): PaymentStatus {
  switch (status) {
    case 'completed': return 'Completed';
    case 'pending': return 'Pending';
    case 'failed': return 'Failed';
    case 'refunded': return 'Failed';
    default: return 'Completed';
  }
}
